module.exports = __webpack_public_path__ + "media/images/plans/e-photo_studio/e-photo_studio-1-302d7e6793cf232d1fa3e298432471c8.png";